var exports = {
  "a": "branchName__a15saO",
  "h": "branchWithButton__kbCe0K",
};

module.exports = exports;
